export interface CameraConfig {
  NODE_ID: string;
  LATITUDE: number;
  DISPLAY_ID: string;
  LONGITUDE: number;
  TIMEZONE_OFFSET: number;
}

export const cameraConfigs: CameraConfig[] = [
  {
    NODE_ID: 'M78863286379',
    LATITUDE: 29.9465,
    DISPLAY_ID: 'D-600 NRCS Projects - MC-78V',
    LONGITUDE: -94.32477,
    TIMEZONE_OFFSET: -21600000,
  },
  {
    NODE_ID: 'M78971146877',
    LATITUDE: 29.77293,
    DISPLAY_ID: 'JD Murphree Structure - MC-78',
    LONGITUDE: -94.04049,
    TIMEZONE_OFFSET: -21600000,
  },
  {
    NODE_ID: 'M68667274267',
    LATITUDE: 29.75131,
    DISPLAY_ID: 'Mayhaw Diversion - MC-68',
    LONGITUDE: -94.34407,
    TIMEZONE_OFFSET: -21600000,
  },
  {
    NODE_ID: 'S71669507017',
    LATITUDE: 29.69079,
    DISPLAY_ID: 'Needmore Structure - SW-701',
    LONGITUDE: -94.1704,
    TIMEZONE_OFFSET: -21600000,
  },
  {
    NODE_ID: 'M78919506878',
    LATITUDE: 29.69076,
    DISPLAY_ID: 'Needmore Structure SW-MC-78',
    LONGITUDE: -94.17093,
    TIMEZONE_OFFSET: -21600000,
  },
  {
    NODE_ID: 'M68641394266',
    LATITUDE: 29.85478,
    DISPLAY_ID: 'Needmore Window - MC-68',
    LONGITUDE: -94.18703,
    TIMEZONE_OFFSET: -21600000,
  },
];
